import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { APP_CONSTANTS, HTTP_HEADERS } from '../constants';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loader: LoaderService,
    private localStorage: Storage) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldSkipLoader = APP_CONSTANTS.skipLoaderUrls.some((url: string) => req.url.includes(url));
    const shouldSkipToken = APP_CONSTANTS.skipTokenUrls.some((url: string) => req.url.includes(url));

    let modifiedReq = req;

    // Attach token unless it's in the skip list
   // const token = this.localStorage.getItem(AppConstants.AUTH_TOKEN);
    const token = "";
    if (token && !shouldSkipToken) {
      modifiedReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    if (shouldSkipLoader) {
      return next.handle(modifiedReq);
    }

    this.loader.show();

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Global error handling can be added here
        console.error('HTTP Error:', error);
        // Optionally, show a notification or redirect
        return throwError(() => error);
      }),
      finalize(() => this.loader.hide())
    );
  }
}
